import {Component, OnInit} from '@angular/core';
import {ContractService} from './contract.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractDetail} from '../models/ContractDetail';
import {Charge} from '../models/Charge';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {BoxAccessUsers} from '../models/BoxAccessUsers';
import {Parameters} from '../models/Parameters';
import {Financial} from '../models/Financial';
import {FinancialService} from '../financial/financial.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {defaultNgxCurrency, Field, FieldBadge, TableModule} from "@cdsistemas/ui";
import {InvoiceNew} from "../models/InvoiceNew";
import {lastValueFrom} from "rxjs";
import {CurrencyPipe, DatePipe, CommonModule} from "@angular/common";
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BoxAccessUserComponent, BoxAccessUserDialogData } from '../box-access-user/box-access-user.component';

@Component({
  selector: 'app-contract',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatTableModule, MatCardModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatIconModule, MatTabsModule, MatTooltipModule, MatMenuModule, MatDialogModule, NgxMaskPipe, NgxCurrencyDirective, TableModule],
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {

  public contract: ContractDetail = {} as ContractDetail;
  public parameters: Parameters = {} as Parameters;
  public id: string;
  public dataSourceFinancial: MatTableDataSource<InvoiceNew> = new MatTableDataSource<InvoiceNew>();
  public form: FormGroup = new FormGroup<any>({
    DESCRICAO_LOJA: new FormControl(''),
    DATA_LOCACAO: new FormControl(''),
    DATA_PREVISAO_TERMINO: new FormControl(''),
    FINALIZAR_CONTRATO_DATA: new FormControl(''),
    VALOR_BASE: new FormControl(''),
    VALOR_MENSALIDADE: new FormControl(''),
  });

  public fieldsFatura: Field[] = [
    {
      fieldName: "CODIGO_FATURA",
      primaryKey: true,
      isCheckbox: false,
      openRoute: true,
      isBadge: false,
      visible: true,
      fieldOrder: 1,
      pipe: value => value,
      canonicalName: "Nº",
      columnClasses: "text-center",
    },
    {
      fieldName: "MES_ANO",
      primaryKey: false,
      isCheckbox: false,
      openRoute: true,
      isBadge: false,
      visible: true,
      fieldOrder: 1,
      pipe: value => value,
      canonicalName: "Mês/Ano",
      columnClasses: "text-center",
    },
    {
      fieldName: "DESCRICAO_FATURA",
      primaryKey: false,
      isCheckbox: false,
      openRoute: true,
      isBadge: false,
      visible: true,
      fieldOrder: 1,
      pipe: value => value,
      canonicalName: "Descrição",
      columnClasses: "",
    },
    {
      fieldName: "DATA_VENCIMENTO",
      primaryKey: false,
      isCheckbox: false,
      openRoute: true,
      isBadge: false,
      visible: true,
      fieldOrder: 1,
      pipe: value => this.datePipe.transform(value),
      canonicalName: "Vencimento",
      columnClasses: "text-center",
    },
    {
      fieldName: "VALOR_TOTAL",
      primaryKey: false,
      isCheckbox: false,
      openRoute: true,
      isBadge: false,
      visible: true,
      fieldOrder: 1,
      pipe: value => this.currencyPipe.transform(value),
      canonicalName: "Valor",
      columnClasses: "text-right",
    },
    {
      fieldName: "DESCRICAO_STATUS",
      primaryKey: false,
      isCheckbox: false,
      openRoute: true,
      isBadge: true,
      badgeConfig: (data: InvoiceNew) => {
        let aux = {
          text: data.DESCRICAO_STATUS,
          color:
            data.CODIGO_STATUS == 1 ? "bg-info" : // Pendente
            data.CODIGO_STATUS == 2 ? "bg-danger" : // Vencido
            data.CODIGO_STATUS == 4 ? "bg-success" : // Pago
              "bg-dark",
        } as FieldBadge;
        return [aux];
      },
      visible: true,
      fieldOrder: 1,
      pipe: value => value,
      canonicalName: "Status",
      columnClasses: "text-center",
    },
  ];

  public dataSourceBoxAccessUsers: MatTableDataSource<BoxAccessUsers> = new MatTableDataSource<BoxAccessUsers>();
  public displayedColumnsBoxAccessUsers: Array<string>;
  public selectedTabIndex = 0;

  public formUsuarioPrincipal: FormGroup = new FormGroup({
    CA_NOME_DISPLAY: new FormControl('', [Validators.required]),
    CA_CODIGO_ACESSO: new FormControl('', [Validators.required]),
  });
  constructor(
    private service: ContractService,
    private route: ActivatedRoute,
    private router: Router,
    private serviceFinancial: FinancialService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private dialog: MatDialog,
  ) {
    this.displayedColumnsBoxAccessUsers = [
      'CPF',
      'NOME',
      'MENSAGEM_ACESSO_LIBERADO',
      'NOME_DISPLAY',
      'CODIGO_ACESSO'
    ];

    this.id = this.route.snapshot.params["id"];
  }

  async ngOnInit(): Promise<any> {
    try {
      this.service.showSpinner();
      this.contract = await lastValueFrom(this.service.getContract(this.id));
      const faturas = await lastValueFrom(this.serviceFinancial.getFinancialList('', this.id));
      this.dataSourceFinancial = new MatTableDataSource<InvoiceNew>(faturas);
      const accessUsers = Array.isArray(this.contract.USUARIOS_ACESSO) ? this.contract.USUARIOS_ACESSO : [];
      this.dataSourceBoxAccessUsers = new MatTableDataSource<BoxAccessUsers>(accessUsers);
      if (this.contract.CONTRATO.INADIMPLENCIA){
        this.service.toasterWarning('Parece que este contrato está inadimplente. Por favor, faça a regularização para garantir acesso ao box.', 'Importante');
      }
      this.formUsuarioPrincipal.patchValue(this.contract.CADASTRO_GERAL);
      this.form.patchValue(this.contract.CONTRATO);
    } catch (e){
      console.error(e);
    } finally {
      this.service.hideSpinner();
    }
  }

  returnToDashboard(): void{
    this.router.navigate(['principal/contratos']);
  }

  public formatDate(value: Date | string | null | undefined): string {
    if (!value) {
      return '—';
    }

    return this.datePipe.transform(value, 'dd/MM/yyyy') ?? '—';
  }

  public formatCurrency(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '—';
    }

    return this.currencyPipe.transform(value, 'BRL', 'symbol', '1.2-2', 'pt-BR') ?? '—';
  }

  public displayValue(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }

    return String(value);
  }

  public displayMeasure(value: number | null | undefined, unit: string): string {
    if (value === null || value === undefined) {
      return '—';
    }

    return `${value.toFixed(2).replace('.', ',')} ${unit}`;
  }

  public get boxSizeLabel(): string {
    if (this.contract?.BOX?.AREA) {
      return `${this.contract.BOX.DESCRICAO_BOX || 'Box'} - ${this.contract.BOX.AREA.toFixed(0).replace('.', ',')}m²`;
    }

    return this.contract?.BOX?.DESCRICAO_BOX || '—';
  }

  public get boxDimensionLabel(): string {
    const box = this.contract?.BOX;
    if (!box) {
      return '—';
    }

    const largura = box.LARGURA ? `${box.LARGURA.toFixed(2).replace('.', ',')} m` : '—';
    const comprimento = (box.COMPRIMENTO || box.PROFUNDIDADE) ? `${(box.COMPRIMENTO || box.PROFUNDIDADE).toFixed(2).replace('.', ',')} m` : '—';
    const altura = box.ALTURA ? `${box.ALTURA.toFixed(2).replace('.', ',')} m` : '—';

    return `${largura} x ${comprimento} x ${altura}`;
  }

  public get boxVolume(): number | null {
    return this.contract.BOX.VOLUME;
    // const box = this.contract?.BOX;
    // if (!box || !box.LARGURA || !(box.COMPRIMENTO || box.PROFUNDIDADE) || !box.ALTURA) {
    //   return null;
    // }
  }

  public get contractStatusLabel(): string {
    return this.contract?.CONTRATO?.INADIMPLENCIA ? 'Inadimplente' : 'Ativo';
  }

  public get statusSummaryText(): string {
    return this.contract?.CONTRATO?.INADIMPLENCIA ? 'Contrato com pendências financeiras.' : 'Contrato em dia.';
  }

  public get contractAgeText(): string {
    const start = this.contract?.CONTRATO?.DATA_LOCACAO ? new Date(this.contract.CONTRATO.DATA_LOCACAO) : null;
    if (!start || Number.isNaN(start.getTime())) {
      return '—';
    }

    const now = new Date();
    const months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
    if (months <= 0) {
      return 'Início recente';
    }

    return `Há ${months} ${months === 1 ? 'mês' : 'meses'}`;
  }

  public get nextInvoice(): InvoiceNew | null {
    const invoices = [...(this.dataSourceFinancial.data ?? [])]
      .filter(invoice => invoice.CODIGO_STATUS !== 4)
      .sort((a, b) => new Date(a.DATA_VENCIMENTO).getTime() - new Date(b.DATA_VENCIMENTO).getTime());

    return invoices[0] ?? null;
  }

  public get lastPaidInvoice(): InvoiceNew | null {
    const paidInvoices = [...(this.dataSourceFinancial.data ?? [])]
      .filter(invoice => invoice.DATA_PAGAMENTO || invoice.CODIGO_STATUS === 4)
      .sort((a, b) => new Date(b.DATA_PAGAMENTO || b.DATA_VENCIMENTO).getTime() - new Date(a.DATA_PAGAMENTO || a.DATA_VENCIMENTO).getTime());

    return paidInvoices[0] ?? null;
  }

  public get totalPaidLast12Months(): number {
    const limit = new Date();
    limit.setMonth(limit.getMonth() - 12);

    return (this.dataSourceFinancial.data ?? [])
      .filter(invoice => (invoice.DATA_PAGAMENTO || invoice.CODIGO_STATUS === 4) && new Date(invoice.DATA_PAGAMENTO || invoice.DATA_VENCIMENTO) >= limit)
      .reduce((sum, invoice) => sum + (invoice.VALOR_TOTAL || 0), 0);
  }

  public get totalOpenAmount(): number {
    return (this.dataSourceFinancial.data ?? [])
      .filter(invoice => invoice.CODIGO_STATUS !== 4)
      .reduce((sum, invoice) => sum + (invoice.VALOR_TOTAL || 0), 0);
  }

  public get totalOverdueAmount(): number {
    const today = new Date();
    return (this.dataSourceFinancial.data ?? [])
      .filter(invoice => invoice.CODIGO_STATUS !== 4 && new Date(invoice.DATA_VENCIMENTO) < today)
      .reduce((sum, invoice) => sum + (invoice.VALOR_TOTAL || 0), 0);
  }

  public get totalOverdueCount(): number {
    const today = new Date();
    return (this.dataSourceFinancial.data ?? [])
      .filter(invoice => invoice.CODIGO_STATUS !== 4 && new Date(invoice.DATA_VENCIMENTO) < today)
      .length;
  }

  public get paymentMethodLabel(): string {
    const invoices = this.dataSourceFinancial.data ?? [];
    if (invoices.some(invoice => invoice.CARTAO_CADASTRADO)) {
      return 'Cartão de crédito';
    }

    if (invoices.some(invoice => invoice.ACEITAR_BOLETO)) {
      return 'Boleto bancário';
    }

    return 'Conforme contratação';
  }

  public get personTypeLabel(): string {
    return this.contract?.CADASTRO_GERAL?.CPF ? 'Pessoa física' : this.contract?.CADASTRO_GERAL?.CNPJ ? 'Pessoa jurídica' : '—';
  }

  public get documentLabel(): string {
    return this.contract?.CADASTRO_GERAL?.CPF || this.contract?.CADASTRO_GERAL?.CNPJ || '—';
  }

  public get hasBoleto(): boolean {
    return (this.dataSourceFinancial.data ?? []).some(invoice => invoice.ACEITAR_BOLETO || !!invoice.CODIGO_BOLETO);
  }

  public get hasCreditCard(): boolean {
    return (this.dataSourceFinancial.data ?? []).some(invoice => invoice.CARTAO_CADASTRADO || !!invoice.DADOS_BASICOS_CARTAO);
  }

  public get totalAccessUsers(): number {
    const secondary = this.dataSourceBoxAccessUsers.data?.length ?? 0;
    const hasMain = !!(this.contract?.CADASTRO_GERAL?.CA_CODIGO_ACESSO || this.contract?.CADASTRO_GERAL?.CA_NOME_DISPLAY);
    return secondary + (hasMain ? 1 : 0);
  }

  public get accessStatusLabel(): string {
    return this.totalAccessUsers > 0 ? 'Configurado' : 'Sem acessos adicionais';
  }

  public get lastAccessChangeDate(): string {
    const latest = [...(this.dataSourceBoxAccessUsers.data ?? [])]
      .sort((a, b) => new Date(b.ALTERACAO_DATA || b.INCLUSAO_DATA).getTime() - new Date(a.ALTERACAO_DATA || a.INCLUSAO_DATA).getTime())[0];

    if (!latest) {
      return '—';
    }

    return this.formatDate(latest.ALTERACAO_DATA || latest.INCLUSAO_DATA);
  }

  public emitSecondCopy(): void {
    if (this.nextInvoice) {
      this.router.navigate(['principal/faturas/' + this.nextInvoice.CODIGO_FATURA]);
      return;
    }

    this.router.navigate(['principal/faturas']);
  }

  public openPaymentHistory(): void {
    this.router.navigate(['principal/faturas']);
  }

  public openAllInvoices(): void {
    this.router.navigate(['principal/faturas']);
  }

  public focusAccessTab(): void {
    this.selectedTabIndex = 2;
  }

  public includeNewBoxUser(codigoContrato: string | number): void {
    const normalizedContractId = this.toInteger(codigoContrato);
    if (!Number.isInteger(normalizedContractId) || normalizedContractId <= 0) {
      return;
    }

    this.openBoxAccessUser({
      id: 0,
      codigoContrato: normalizedContractId,
    });
  }

  public saveMainUserData(): void{
    this.service.showSpinner();
    this.service.saveMainAccessControl(this.id, this.formUsuarioPrincipal.getRawValue()).subscribe(data => {
      this.service.hideSpinner();
      this.service.toasterSuccess('Dados atualizados', 'Sucesso!');
    }, err => {
      this.service.hideSpinner();
      this.service.toasterError('Houve um erro ao salvar seus dados. Tente mais tarde');
    });
  }

  public loadDataBoxAccessUser = (id: string | number, codigoContrato: string | number): void => {
    const normalizedId = this.toInteger(id);
    const normalizedContractId = this.toInteger(codigoContrato);
    if (!Number.isInteger(normalizedId) || normalizedId <= 0 ||
      !Number.isInteger(normalizedContractId) || normalizedContractId <= 0) {
      return;
    }

    this.openBoxAccessUser({
      id: normalizedId,
      codigoContrato: normalizedContractId,
    });
  }

  private openBoxAccessUser(data: BoxAccessUserDialogData): void {
    this.dialog.open(BoxAccessUserComponent, {
      width: 'min(720px, calc(100vw - 32px))',
      maxWidth: '100vw',
      maxHeight: '92vh',
      data,
    }).afterClosed().subscribe(result => {
      if (result?.changed) {
        this.refreshAccessUsers();
      }
    });
  }

  private refreshAccessUsers(): void {
    this.service.showSpinner();
    this.service.getContract(this.id).subscribe({
      next: contract => {
        this.contract = contract;
        const accessUsers = Array.isArray(contract.USUARIOS_ACESSO) ? contract.USUARIOS_ACESSO : [];
        this.dataSourceBoxAccessUsers = new MatTableDataSource<BoxAccessUsers>(accessUsers);
      },
      error: error => {
        console.error(error);
        this.service.toasterWarning('Não foi possível atualizar os acessos do contrato.');
        this.service.hideSpinner();
      },
      complete: () => this.service.hideSpinner(),
    });
  }

  private toInteger(value: string | number): number {
    if (typeof value === 'string' && !/^\d+$/.test(value.trim())) {
      return NaN;
    }

    return Number(value);
  }
  protected readonly defaultNgxCurrency = defaultNgxCurrency;
}
